/** A lane's page tabs, in order; kept in the URL as `?tab=`. */
export const LANE_TABS = [
  "overview",
  "routing",
  "servers",
  "traffic",
  "activity",
] as const

export type LaneTab = (typeof LANE_TABS)[number]

/** Overview is the default, so it never appears in the URL. */
export function parseLaneTab(value: unknown): Exclude<LaneTab, "overview"> | undefined {
  return LANE_TABS.find((t) => t !== "overview" && t === value) as
    | Exclude<LaneTab, "overview">
    | undefined
}
